import React, { useEffect } from "react";
import { Modal, ModalBody } from "@vds/modals";
import { Title } from "@vds/typography";
import { css } from "@emotion/react";
import { CustomSLButton, FlexRow, Spacer, MediumText } from "../../components/core/utility";
import { Icon } from "@vds/icons";

export const StyledModal = css`
  max-height: 99vmin;
  padding: 1rem 1rem 1rem 1rem;
  padding-right: 2px;
  border-radius: 0.5rem !important;
  @media (max-width: 767px) {
    width: 560px !important;
    height: auto;
    min-height: 14.5rem;
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 2px;
  }

  & footer {
    padding: 0;
  }
`;

const ConfirmationModal = ({ isConfirmationModal, setIsConfirmationModal, handleContinue, modalHeading, modalBody, actionName, handleNo }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setIsConfirmationModal(false);
      }
    };
    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Modal
        role="dialog"
        ariaLabel="Confirmation Modal"
        hideCloseButton={false}
        opened={isConfirmationModal}
        disableOutsideClick
        css={StyledModal}
        closeButton={
          <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
            <div>
              <Title size="medium">{modalHeading}</Title>
            </div>
            <div
              data-testId="close-icon"
              onClick={() => {
                setIsConfirmationModal(false);
              }}
              style={{ marginRight: "1rem", marginTop: "0.3rem" }}
            >
              <Icon
                aria-label="close"
                alt="close-icon"
                role="img"
                name="close"
                size="medium"
                color="#000000"
                style={{ cursor: "pointer", outline: "none" }}
              />
            </div>
          </FlexRow>
        }
      >
        <ModalBody css={{ paddingLeft: "0", paddingRight: "0", marginTop: "0.5rem" }}>
          <MediumText>{modalBody}</MediumText>
          {actionName !== "contact" && actionName !== "assignment" && actionName !== "create_workticket" && actionName !== "back" && (
            <Spacer top="1rem" />
          )}
          {actionName !== "contact" && actionName !== "assignment" && actionName !== "create_workticket" && actionName !== "back" && (
            <MediumText>
              <strong>WARNING:</strong> The &#39;Return only after cancellation&#39; action is restricted to agents who process SAN cases (ADS).
            </MediumText>
          )}
          <Spacer top="3rem" />
          <FlexRow style={{ marginLeft: "35%" }}>
            {actionName !== "back" && (
              <CustomSLButton
                aria-label="No"
                role="button"
                secondary
                onClick={() => {
                  actionName === "contact" ? handleNo() : setIsConfirmationModal(false);
                }}
              >
                {actionName === "contact" ? "No" : "Cancel"}
              </CustomSLButton>
            )}
            <CustomSLButton
              aria-label="Yes"
              role="button"
              css={{ padding: "0 10px 0 10px" }}
              primary
              onClick={() => {
                handleContinue();
              }}
            >
              {actionName === "contact" ? "Yes" : "Continue"}
            </CustomSLButton>
          </FlexRow>
        </ModalBody>
      </Modal>
    </>
  );
};
export default ConfirmationModal;
